import { log } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import {
  ADMIN_MONITORING_ENDPOINTS,
  AdminFeatureMonitoringResponse,
  AdminFeatureMonitoringSectionId,
  CronJobLogDetail,
  CronJobLogEnvironment,
  CronJobLogsQueryParams,
  CronJobLogsResponse,
} from "../models/admin-monitoring.models";
import axios from "axios";

const cleanParams = (params: CronJobLogsQueryParams) =>
  Object.entries(params).reduce<Record<string, string | number | boolean>>((cleaned, [key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      cleaned[key] = value;
    }
    return cleaned;
  }, {});

export const getCronJobLogs = async (params: CronJobLogsQueryParams): Promise<CronJobLogsResponse> => {
  const response = await api.get(`${apiUrl}/admin/monitoring/cron-job-logs`, {
    params: cleanParams(params),
  });
  log("REPO - getCronJobLogs - response", { status: response.status, count: response.data?.entries?.length });

  return response.data;
};

export const getCronJobLogDetail = async (
  id: string,
  environment: CronJobLogEnvironment,
): Promise<CronJobLogDetail> => {
  const response = await api.get(`${apiUrl}/admin/monitoring/cron-job-logs/${encodeURIComponent(id)}`, {
    params: { environment },
  });
  log("REPO - getCronJobLogDetail - response", { status: response.status });
  return response.data;
};

export const getAdminFeatureMonitoring = async (
  section: AdminFeatureMonitoringSectionId,
  environment: CronJobLogEnvironment,
): Promise<AdminFeatureMonitoringResponse> => {
  const response = await api.get(`${apiUrl}/admin/monitoring/${ADMIN_MONITORING_ENDPOINTS[section]}`, {
    params: { environment },
  });

  log("REPO - getAdminFeatureMonitoring - response", { status: response.status, section });

  return response.data;
};

export const getAdminMonitoringErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Monitoring request failed.";
};
